import type { FC, PropsWithChildren } from 'react';
import React, { Suspense, lazy } from 'react';

import type { LivePersonaCardGroupProps } from './LivePersonaCardGroup';

const LivePersonaCardGroup = lazy(
  () => import(/* webpackChunkName: "4-feat-live-persona-card-group" */ './LivePersonaCardGroupErrorBoundary')
);

const LoadableLivePersonaCardGroup: FC<PropsWithChildren<LivePersonaCardGroupProps>> = (props) => (
  <Suspense fallback={<>{props.children}</>}>
    <LivePersonaCardGroup {...props} />
  </Suspense>
);

export default LoadableLivePersonaCardGroup;
